import { styled } from '@nykaa/ui-components';
import { truncate } from 'shared/styles/mixin';

export const AuthContainer = styled.div<{ isColumn?: boolean; }>`
  display: flex;
  flex-direction: ${({ isColumn }) => (isColumn ? 'column' : 'row')};
  align-items: center;
  margin-left: ${({ theme }) => theme.spacing.spacing120};
  margin-top: ${({ theme }) => theme.spacing.spacing40};
  text-transform: capitalize;
  color: inherit;
`;

export const TextContainer = styled.div`
  width: 100%;
  ${({ theme }) => theme.typography.titleSmall};
  min-width: 3.5rem;

  ${truncate}
`;

export const IconWrapper = styled.span<{ isColumn?: boolean; }>`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: ${({ theme, isColumn }) => (isColumn ? theme.spacing.spacing0 : theme.spacing.spacing40)};
  width: ${({ theme }) => theme.spacing.spacing120};
  height: ${({ theme }) => theme.spacing.spacing120};
  flex-shrink: 0;
`;
